var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { useAccountSummaryV2Query } from 'syf-api';
import RenderIf from 'syf-component-library/ui/atoms/RenderIf';
import { VerticalCardLoader } from 'syf-component-library/ui/atoms';
import { Inset } from 'syf-component-library/ui/spacing';
import { triggerAnalyticsEvent } from 'syf-js-utilities';
import { AnalyticsValues, TriggerAnalyticsKeys } from '../../../const/analytics';
import useEligibilityQuery from '../../../services/eligibility/eligibility-query';
import useProfileQuery from '../../../services/profile/profile-query';
import { errorCodesNumber } from '../../../const/errorCodes';
import store from '../../../helpers/store';
import { STORE_KEYS } from '../../../const/store-keys';
import routes from '../../../const/routes';
import { accountIdType } from '../../../const/config';
import CBRContext from '../context';
import CardHeader from './cardHeader';
import ReviewBalanceOptions from './reviewBalanceOptions';
import RefundRequestDetails from './refundRequestDetails';
import RefundRequestStatus from './refundRequestInStatus';
import { ModalOptions } from '../../../typings/common';
import GenericError from '../error/generic-error';
import NetworkErrorIllustration from '../../illustrations/network-error';
var Drawer = function (_a) {
    var _b, _c;
    var authenticationRedirect = _a.authenticationRedirect, currentDrawer = _a.currentDrawer, setCurrentDrawer = _a.setCurrentDrawer;
    var _d = useState(false), drawerReady = _d[0], setDrawerReady = _d[1];
    var _e = useContext(CBRContext), config = _e.config, accountId = _e.accountId, setIsLoading = _e.setIsLoading, setRemoveCBRSessionStorage = _e.setRemoveCBRSessionStorage;
    var accountSummary = useAccountSummaryV2Query({
        config: config,
        keyProps: {
            accountId: accountId,
            accountIdType: accountIdType
        },
        queryOptions: {
            enabled: Boolean(accountId)
        }
    }).data;
    var _f = useEligibilityQuery({
        config: config,
        keyProps: {
            accountId: accountId,
            accountIdType: accountIdType
        },
        queryOptions: {
            refetchOnMount: 'always'
        }
    }), eligibilityData = _f.data, isEligibilityFetching = _f.isFetching, isEligibilityError = _f.isError;
    useEffect(function () {
        var _a;
        var isBusinessErrorStatusCode = (eligibilityData === null || eligibilityData === void 0 ? void 0 : eligibilityData.statusCode) === 422;
        var businessErrorCode = (_a = eligibilityData === null || eligibilityData === void 0 ? void 0 : eligibilityData.businessErrors) === null || _a === void 0 ? void 0 : _a.some(function (err) { return err.code === errorCodesNumber.refundInProgress; });
        var isRefundInProgress = isBusinessErrorStatusCode && businessErrorCode;
        var onSubmissionScreen = store.get(STORE_KEYS.isCbrExecution, 'session');
        if (onSubmissionScreen) {
            setCurrentDrawer(ModalOptions.refundRequest);
        }
        if (isRefundInProgress) {
            setCurrentDrawer(ModalOptions.inProgress);
        }
        if (eligibilityData) {
            setDrawerReady(true);
        }
        return function () {
            setDrawerReady(false);
            setCurrentDrawer(ModalOptions.default);
        };
    }, [
        eligibilityData,
        eligibilityData === null || eligibilityData === void 0 ? void 0 : eligibilityData.businessErrors,
        eligibilityData === null || eligibilityData === void 0 ? void 0 : eligibilityData.statusCode,
        setCurrentDrawer
    ]);
    var currentBalance = (_c = (_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.credit) === null || _b === void 0 ? void 0 : _b.currentBalance) !== null && _c !== void 0 ? _c : '0.00';
    var isInProgressDrawer = currentDrawer === ModalOptions.inProgress;
    var _g = useProfileQuery({
        config: config,
        keyProps: {
            accountId: accountId,
            accountIdType: accountIdType
        },
        queryOptions: {
            enabled: false,
            staleTime: Infinity
        }
    }), profileData = _g.data, refetch = _g.refetch;
    var profileStatusCode = profileData === null || profileData === void 0 ? void 0 : profileData.statusCode;
    useEffect(function () {
        if (accountId && profileStatusCode === 204) {
            store.set(STORE_KEYS.isProfileEnabled, true, 'session');
            refetch();
        }
        store.set(STORE_KEYS.isProfileEnabled, false, 'session');
    }, [accountId, refetch, profileStatusCode]);
    var onRefundRequestExecution = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, isSuccess, isError, error, errorCode;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setRemoveCBRSessionStorage === null || setRemoveCBRSessionStorage === void 0 ? void 0 : setRemoveCBRSessionStorage(false);
                    setIsLoading === null || setIsLoading === void 0 ? void 0 : setIsLoading(true);
                    return [4 /*yield*/, refetch()];
                case 1:
                    _a = _c.sent(), isSuccess = _a.isSuccess, isError = _a.isError, error = _a.error;
                    errorCode = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status;
                    store.set(STORE_KEYS.isCbrExecution, true, 'session');
                    if (isSuccess) {
                        setCurrentDrawer(ModalOptions.refundRequest);
                        setIsLoading === null || setIsLoading === void 0 ? void 0 : setIsLoading(false);
                    }
                    // If useProfileScopeQuery has an error(403), redirects to OTP page
                    if (isError && errorCode === 403) {
                        authenticationRedirect({
                            scope: 'read write write:sensitive profile:read:sensitive',
                            navigateTo: routes.HOME,
                            modal: 'CreditBalanceRefund'
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        if (isEligibilityError || currentDrawer === ModalOptions.refundError) {
            triggerAnalyticsEvent((_a = {},
                _a[TriggerAnalyticsKeys.pageKind] = AnalyticsValues.cbr,
                _a[TriggerAnalyticsKeys.pageFunction] = AnalyticsValues.manageCreditBalance,
                _a[TriggerAnalyticsKeys.message] = AnalyticsValues.errorMessage,
                _a[TriggerAnalyticsKeys.pageName] = AnalyticsValues.error,
                _a));
        }
    }, [isEligibilityError, currentDrawer]);
    if (isEligibilityError || currentDrawer === ModalOptions.refundError) {
        return (_jsx(Inset, { children: _jsx(GenericError, { image: _jsx(NetworkErrorIllustration, {}), titleKey: "error.networkHeading", subtitleKey: "error.networkMessage" }) }));
    }
    if (!drawerReady) {
        return (_jsx(Inset, { children: _jsx(VerticalCardLoader, {}) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(RenderIf, __assign({ condition: !isInProgressDrawer }, { children: _jsx(CardHeader, {}) })), _jsx(RenderIf, __assign({ condition: currentDrawer === ModalOptions.default }, { children: _jsx(ReviewBalanceOptions, { currentBalance: currentBalance, eligibilityData: eligibilityData, isEligibilityFetching: isEligibilityFetching, onRefundRequestExecution: onRefundRequestExecution }) })), _jsx(RenderIf, __assign({ condition: currentDrawer === ModalOptions.refundRequest }, { children: _jsx(RefundRequestDetails, { authenticationRedirect: authenticationRedirect, currentBalance: currentBalance, setCurrentDrawer: setCurrentDrawer }) })), _jsx(RenderIf, __assign({ condition: isInProgressDrawer }, { children: _jsx(RefundRequestStatus, { currentModal: currentDrawer }) })), _jsx(RenderIf, __assign({ condition: currentDrawer === ModalOptions.success }, { children: _jsxs(_Fragment, { children: [_jsx(RefundRequestStatus, { currentModal: currentDrawer }), _jsx(RefundRequestDetails, { authenticationRedirect: authenticationRedirect, currentBalance: currentBalance, isSuccessModal: true })] }) }))] }));
};
export default Drawer;
